import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';
// frontend/src/components/admin/KitForm.jsx - COMPLETO CON IMAGE UPLOAD
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    FormControlLabel,
    Switch,
    Box,
    Typography,
    IconButton,
    Alert,
    InputAdornment,
    Autocomplete,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction
} from '@mui/material';
import {
    Add as AddIcon,
    Delete as DeleteIcon,
    Remove as RemoveIcon
} from '@mui/icons-material';

import { ecommerceApi, cartHelpers } from '../../services/ecommerceApi';
import ImageUpload from '../common/ImageUpload'; // ✅ IMPORTAR ImageUpload

const KitForm = ({ open, onClose, onSave, kit }) => {
  const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        sku: '',
        price: '',
        compare_price: '',
        is_active: true,
        is_featured: false,
        main_image: '',
        images: [],
        products: [],
        kit_type: '',
        template_key: '',
        valve_total_required: 0,
        valve_mix_config: null,
    });

    const [errors, setErrors] = useState({});
    const [allProducts, setAllProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productQuantity, setProductQuantity] = useState(1);

    useEffect(() => {
        loadProducts();
    }, []);

    useEffect(() => {
        if (kit) {
            setFormData({
                name: kit.name || '',
                description: kit.description || '',
                sku: kit.sku || '',
                price: kit.price?.toString() || '',
                compare_price: kit.compare_price?.toString() || '',
                is_active: kit.is_active !== undefined ? kit.is_active : true,
                is_featured: kit.is_featured || false,
                main_image: kit.main_image || '',
                images: kit.images || [],
                products: kit.products || [],
                kit_type: kit.kit_type || '',
                template_key: kit.template_key || '',
                valve_total_required: kit.valve_total_required || 0,
                valve_mix_config: kit.valve_mix_config || null,
            });
        } else {
            setFormData({
                name: '',
                description: '',
                sku: '',
                price: '',
                compare_price: '',
                is_active: true,
                is_featured: false,
                main_image: '',
                images: [],
                products: [],
                kit_type: '',
                template_key: '',
                valve_total_required: 0,
                valve_mix_config: null,
            });
        }
        setErrors({});
    }, [kit, open]);

    const loadProducts = async () => {
        try {
            const response = await ecommerceApi.products.getAll({
                per_page: 100,
                is_active: true
            });
            setAllProducts(response.data.items || []);
        } catch (error) {
            console.error(t('hardcoded.components_admin_kitform.error_loading_products'), error);
        }
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    // ✅ NUEVO: Handler para ImageUpload
    const handleImageChange = ({ images, mainImage }) => {
        setFormData(prev => ({
            ...prev,
            images,
            main_image: mainImage
        }));
    };

    const addProductToKit = () => {
        if (!selectedProduct || productQuantity < 1) return;

        const exists = formData.products.find(p => p.product_id === selectedProduct.id);
        if (exists) {
            alert(t('hardcoded.components_admin_kitform.este_producto_ya_esta_en'));
            return;
        }

        setFormData(prev => ({
            ...prev,
            products: [
                ...prev.products,
                {
                    product_id: selectedProduct.id,
                    quantity: productQuantity,
                    is_valve: selectedProduct?.category?.name?.toLowerCase?.().includes(t('hardcoded.components_admin_kitform.valv')) || false,
                    _productData: selectedProduct
                }
            ]
        }));

        setSelectedProduct(null);
        setProductQuantity(1);
    };

    const removeProductFromKit = (productId) => {
        setFormData(prev => ({
            ...prev,
            products: prev.products.filter(p => p.product_id !== productId)
        }));
    };

    const updateProductQuantity = (productId, newQuantity) => {
        if (newQuantity < 1) {
            removeProductFromKit(productId);
            return;
        }

        setFormData(prev => ({
            ...prev,
            products: prev.products.map(p =>
                p.product_id === productId ? { ...p, quantity: newQuantity } : p
            )
        }));
    };

    const calculateTotalPrice = () => {
        let total = 0;
        formData.products.forEach(item => {
            const product = item._productData || allProducts.find(p => p.id === item.product_id);
            if (product) {
                total += parseFloat(product.price) * item.quantity;
            }
        });
        return total;
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = t('hardcoded.components_admin_categoryform.nombre_es_requerido');
        if (!formData.sku.trim()) newErrors.sku = t('hardcoded.components_admin_kitform.sku_es_requerido');
        if (!formData.price || parseFloat(formData.price) <= 0) {
            newErrors.price = t('hardcoded.components_admin_kitform.precio_debe_ser_mayor_a');
        }
        if (formData.compare_price && parseFloat(formData.compare_price) <= parseFloat(formData.price)) {
            newErrors.compare_price = t('hardcoded.components_admin_kitform.precio_de_comparacion_debe_ser');
        }
        if (formData.products.length === 0) {
            newErrors.products = t('hardcoded.components_admin_kitform.debes_agregar_al_menos_un');
        }

        const valveDefined = formData.products
            .filter((p) => p.is_valve)
            .reduce((acc, curr) => acc + Number(curr.quantity || 0), 0);
        if (Number(formData.valve_total_required || 0) > 0 && valveDefined > Number(formData.valve_total_required || 0)) {
            newErrors.valve_total_required = t('hardcoded.components_admin_kitform.la_mezcla_de_valvulas_excede');
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        if (!validateForm()) return;

        const saveData = {
            ...formData,
            price: parseFloat(formData.price),
            compare_price: formData.compare_price ? parseFloat(formData.compare_price) : null,
            valve_total_required: parseInt(formData.valve_total_required || 0, 10),
            valve_mix_config: {
                required_total: parseInt(formData.valve_total_required || 0, 10),
                defined_total: formData.products
                    .filter((p) => p.is_valve)
                    .reduce((acc, curr) => acc + Number(curr.quantity || 0), 0),
            },
            products: formData.products.map(p => ({
                product_id: p.product_id,
                quantity: p.quantity,
                is_valve: !!p.is_valve,
            }))
        };

        onSave(saveData);
    };

    const totalCalculated = calculateTotalPrice();
    const savingsAmount = formData.compare_price ?
        parseFloat(formData.compare_price) - parseFloat(formData.price || 0) : 0;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {kit ? t('hardcoded.components_admin_kitform.editar_kit_de_productos') : t('hardcoded.components_admin_kitform.crear_kit_de_productos')}
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            {t('audit.detail.basicInfo')}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={t('hardcoded.components_admin_kitform.nombre_del_kit')}
                            value={formData.name}
                            onChange={(e) => handleChange('name', e.target.value)}
                            error={!!errors.name}
                            helperText={errors.name}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="SKU *"
                            value={formData.sku}
                            onChange={(e) => handleChange('sku', e.target.value)}
                            error={!!errors.sku}
                            helperText={errors.sku}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={t('audit.table.description')}
                            value={formData.description}
                            onChange={(e) => handleChange('description', e.target.value)}
                            multiline
                            rows={3}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            {i18n.t('hardcoded.components_admin_kitform.precios')}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={t('hardcoded.components_admin_kitform.precio_del_kit')}
                            type="number"
                            value={formData.price}
                            onChange={(e) => handleChange('price', e.target.value)}
                            error={!!errors.price}
                            helperText={errors.price || t('hardcoded.components_admin_kitform.valor_calculado_carthelpersform', { cartHelpersform: cartHelpers.formatCurrency(totalCalculated) })}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={t('hardcoded.components_admin_kitform.precio_de_comparacion')}
                            type="number"
                            value={formData.compare_price}
                            onChange={(e) => handleChange('compare_price', e.target.value)}
                            error={!!errors.compare_price}
                            helperText={errors.compare_price || t('hardcoded.components_admin_kitform.para_mostrar_ahorros')}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>
                            }}
                        />
                    </Grid>

                    {savingsAmount > 0 && (
                        <Grid item xs={12}>
                            <Alert severity="success">
                                <Typography variant="body2">
                                    <strong>{t('hardcoded.components_admin_kitform.ahorro_para_el_cliente')}</strong> {cartHelpers.formatCurrency(savingsAmount)}
                                    ({((savingsAmount / parseFloat(formData.compare_price || 1)) * 100).toFixed(0)}%)
                                </Typography>
                            </Alert>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            {t('hardcoded.components_admin_kitform.productos_del_kit')}</Typography>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label={t('hardcoded.components_admin_kitform.tipo_de_kit')}
                            value={formData.kit_type}
                            onChange={(e) => handleChange('kit_type', e.target.value)}
                            helperText={t('hardcoded.components_admin_kitform.ej_tracto-10_remolque-8')}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label={t('hardcoded.components_admin_kitform.clave_de_plantilla')}
                            value={formData.template_key}
                            onChange={(e) => handleChange('template_key', e.target.value)}
                            helperText={t('hardcoded.components_admin_kitform.permite_clonarreusar_configuracion')}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            type="number"
                            label={t('hardcoded.components_admin_kitform.total_valvulas_genericas')}
                            value={formData.valve_total_required}
                            onChange={(e) => handleChange('valve_total_required', e.target.value)}
                            error={!!errors.valve_total_required}
                            helperText={errors.valve_total_required || t('hardcoded.components_admin_kitform.define_cupo_total_para_mezcla')}
                        />
                    </Grid>

                    {errors.products && (
                        <Grid item xs={12}>
                            <Alert severity="error">{errors.products}</Alert>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Box sx={{ mb: 2 }}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Autocomplete
                                        options={allProducts}
                                        getOptionLabel={(option) => `${option.name} - ${option.sku}`}
                                        value={selectedProduct}
                                        onChange={(e, newValue) => setSelectedProduct(newValue)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('hardcoded.components_admin_kitform.buscar_producto')}
                                                placeholder={t('hardcoded.components_admin_kitform.escribe_para_buscar')}
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                                    <Box
                                                        component="img"
                                                        src={option.main_image_url || '/images/placeholder-product.jpg'}
                                                        alt={option.name}
                                                        sx={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 1 }}
                                                    />
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="body2" fontWeight={600}>
                                                            {option.name}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                            SKU: {option.sku} | {cartHelpers.formatCurrency(option.price)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <TextField
                                        fullWidth
                                        label={t('hardcoded.components_admin_kitform.cantidad')}
                                        type="number"
                                        value={productQuantity}
                                        onChange={(e) => setProductQuantity(parseInt(e.target.value) || 1)}
                                        inputProps={{ min: 1 }}
                                    />
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={addProductToKit}
                                        disabled={!selectedProduct}
                                        startIcon={<AddIcon />}
                                    >
                                        Agregar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>

                        {formData.products.length > 0 ? (
                            <List>
                                {formData.products.map((item) => {
                                    const product = item._productData || allProducts.find(p => p.id === item.product_id);
                                    if (!product) return null;

                                    return (
                                        <ListItem
                                            key={item.product_id}
                                            sx={{
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 1,
                                                mb: 1
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={product.main_image_url || '/images/placeholder-product.jpg'}
                                                alt={product.name}
                                                sx={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 1, mr: 2 }}
                                            />
                                            <ListItemText
                                                primary={product.name}
                                                secondary={
                                                    <Box>
                                                        <Typography variant="caption" display="block">
                                                            SKU: {product.sku}
                                                        </Typography>
                                                        <Typography variant="caption" display="block">
                                                            {i18n.t('hardcoded.components_admin_kitform.precio_unitario')}{cartHelpers.formatCurrency(product.price)}
                                                        </Typography>
                                                        <Typography variant="caption" display="block" fontWeight={600}>
                                                            {i18n.t('hardcoded.components_admin_kitform.subtotal')}{cartHelpers.formatCurrency(product.price * item.quantity)}
                                                        </Typography>
                                                        {item.is_valve && (
                                                            <Typography variant="caption" display="block" color="secondary.main" fontWeight={600}>
                                                                {t('hardcoded.components_admin_kitform.producto_de_valvula_mezcla_controlada')}</Typography>
                                                        )}
                                                    </Box>
                                                }
                                            />
                                            <ListItemSecondaryAction>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => updateProductQuantity(item.product_id, item.quantity - 1)}
                                                    >
                                                        <RemoveIcon />
                                                    </IconButton>
                                                    <Typography sx={{ minWidth: 30, textAlign: 'center' }}>
                                                        {item.quantity}
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => updateProductQuantity(item.product_id, item.quantity + 1)}
                                                    >
                                                        <AddIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => removeProductFromKit(item.product_id)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        ) : (
                            <Alert severity="info">
                                {t('hardcoded.components_admin_kitform.no_hay_productos_en_el')}</Alert>
                        )}

                        {Number(formData.valve_total_required || 0) > 0 && (
                            <Alert severity="info" sx={{ mt: 2 }}>
                                {t('hardcoded.components_admin_kitform.mezcla_de_valvulas')}{formData.products.filter((p) => p.is_valve).reduce((acc, p) => acc + Number(p.quantity || 0), 0)} de {Number(formData.valve_total_required || 0)}
                            </Alert>
                        )}
                    </Grid>

                    {/* ✅ NUEVO: Usar ImageUpload component */}
                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            {t('hardcoded.components_admin_kitform.imagenes')}</Typography>
                        <ImageUpload
                            images={formData.images}
                            mainImage={formData.main_image}
                            onChange={handleImageChange}
                            maxImages={10}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            {i18n.t('navbar.settings')}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.is_active}
                                    onChange={(e) => handleChange('is_active', e.target.checked)}
                                />
                            }
                            label={t('hardcoded.components_admin_kitform.kit_activo')}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.is_featured}
                                    onChange={(e) => handleChange('is_featured', e.target.checked)}
                                />
                            }
                            label={t('hardcoded.components_admin_kitform.kit_destacado')}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    {t('common.cancel')}</Button>
                <Button onClick={handleSave} variant="contained">
                    {kit ? t('audit.actions.UPDATE') : t('audit.actions.CREATE')} Kit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default KitForm;